import { Environment } from '@dice/app/types/env.type';
import { INT_ENV_CONFIG } from '@dice/environments/int/int.env';
import { NgxLoggerLevel } from 'ngx-logger';

export const INT_1_ENV_CONFIG: Environment = {
  ...INT_ENV_CONFIG,
  hostNames: ['dice-pre-1.scapp-corp.swisscom.com', 'localhost:2001'],
  enableDebugInfo: true,
  isProduction: false,
  variant: 'dice-ui-int-1',
  logLevel: NgxLoggerLevel.DEBUG,
  budaStatusURL: 'https://dice-pre-1.scapp-corp.swisscom.com/status',
};
